var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import Axios from 'axios';
import to from 'await-to-js';
import constants from '../constants/global-constants';
var sandboxDbUser = {
    get: function (accessToken) { return __awaiter(void 0, void 0, void 0, function () {
        var _a, err, response;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, to(Axios.get("".concat(constants.API_BASE_URL_v2, "/SandboxGetUserInfo"), {
                        headers: {
                            authorization: accessToken,
                        },
                    }))];
                case 1:
                    _a = _b.sent(), err = _a[0], response = _a[1];
                    return [2 /*return*/, [err, response ? response.data : null]];
            }
        });
    }); },
    update: function (body, accessToken) { return __awaiter(void 0, void 0, void 0, function () {
        var _a, err, response;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, to(Axios.post("".concat(constants.API_BASE_URL_v2, "/SandboxSaveUserInfo"), JSON.stringify(body), {
                        headers: {
                            authorization: accessToken,
                        },
                    }))];
                case 1:
                    _a = _b.sent(), err = _a[0], response = _a[1];
                    return [2 /*return*/, [err, response]];
            }
        });
    }); },
    generateApiKey: function (accessToken) { return __awaiter(void 0, void 0, void 0, function () {
        var _a, err, response;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, to(Axios.post("".concat(constants.API_BASE_URL_v2, "/SandboxGenerateApiKey"), {}, {
                        headers: {
                            authorization: accessToken,
                        },
                    }))];
                case 1:
                    _a = _b.sent(), err = _a[0], response = _a[1];
                    return [2 /*return*/, [err, response ? response.data : null]];
            }
        });
    }); },
};
var sendVerificationEmail = function (accessToken) { return __awaiter(void 0, void 0, void 0, function () {
    var _a, err, response;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0: return [4 /*yield*/, to(Axios.post("".concat(constants.API_BASE_URL_v2, "/SandboxResendEmailVerification"), {}, {
                    headers: {
                        Authorization: "Bearer " + accessToken,
                    },
                }))];
            case 1:
                _a = _b.sent(), err = _a[0], response = _a[1];
                return [2 /*return*/, [err, response && response.data]];
        }
    });
}); };
// Rafal: Verified, ok
var addConditionalLead = function (params, accessToken) { return __awaiter(void 0, void 0, void 0, function () {
    var _a, err, res;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0: return [4 /*yield*/, to(Axios.post("".concat(constants.API_BASE_URL_v2, "/SandboxConditionalAddLead"), JSON.stringify(params), {
                    headers: {
                        Authorization: accessToken,
                    },
                }))];
            case 1:
                _a = _b.sent(), err = _a[0], res = _a[1];
                return [2 /*return*/, [err, res && res.data]];
        }
    });
}); };
// Rafal: verified, not working, not related to Onboarding
var sendWebLinkEmail = function (email) { return __awaiter(void 0, void 0, void 0, function () {
    var _a, err, res;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0: return [4 /*yield*/, to(Axios.post("".concat(constants.NODE_API_BASE_URL, "/SandboxSendWebLinkEmail"), {
                    email: email,
                }))];
            case 1:
                _a = _b.sent(), err = _a[0], res = _a[1];
                return [2 /*return*/, [err, res ? res.data : null]];
        }
    });
}); };
export default {
    sendVerificationEmail: sendVerificationEmail,
    addConditionalLead: addConditionalLead,
    sandboxDbUser: sandboxDbUser,
    sendWebLinkEmail: sendWebLinkEmail,
};
